import { MdCheckCircle, MdContentCopy } from "react-icons/md";
import React, { useState } from "react";

type Props = {
  content: string;
};

const CopyToClipboard = ({ content }: Props) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  function copy() {
    navigator.clipboard.writeText(content);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
  }

  return (
    <button
      onClick={copy}
      className="p-1 text-xs md:text-sm bg-medium-dark-grey text-white rounded"
    >
      <div className="flex flex-row justify-center items-center p-px">
        {isCopied ? (
          <MdCheckCircle className="w-4 h-4 md:w-6 md-h-6" />
        ) : (
          <MdContentCopy className="w-4 h-4 md:w-6 md-h-6" />
        )}
      </div>
    </button>
  );
};
export default CopyToClipboard;
